__turbopack_context__.v({
  "className": "circularstd_c66fab9a-module__LAVgTa__className",
});
